module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.getRecords()
      }
    }
  }, [_vm._v("Refresh")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "LogName",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mod",
      "label": "Created",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "View Log",
      "visible": _vm.editFormVisible,
      "width": "90%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" XLog")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['name']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'name', $$v)
      },
      expression: "editForm['name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Created : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['mod']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'mod', $$v)
      },
      expression: "editForm['mod']"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "15"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c3ed939"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/xlog.vue
// module id = 643
// module chunks = 1